import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/page',
        method: 'post',
        data: {
            ...params,
            current,
            size
        }
    })
}

export const remove = (id) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/remove',
        method: 'post',
        data: {
            id,
        }
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/update_rate_tenancy_term',
        method: 'post',
        data: row
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/submit_rate_tenancy_term',
        method: 'post',
        data: row
    })
}

export const updateRebateRatio = (row) => {
  return request({
      url: '/api/blade-loanProductManagement/loanProductManagement/update_rebate_ratio',
      method: 'post',
      data: row
  })
}

// 产品大纲 不分液
export const loanProductManagementList = (row) => {
  return request({
      url: '/api/blade-loanProductManagement/loanProductManagement/list',
      method: 'post',
      data: row
  })
}
